import React from "react";
import ByzMuiDataGrid from "src/components/core-components/mui/data-grid";
import {
  GridColDef,

} from "@mui/x-data-grid-premium";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";
import { getColumns, rows as eveningRows } from "./data";
import { useTranslate } from "src/locales";
import ByzDataGridToolbar from "src/components/core-components/mui/data-grid/toolbar";
//IDOGAN;449733;25042025

interface PageEveningProops {
  startDate: Date | null;
  endDate: Date | null;
  selectedIds: number[];
  onToggleRow: (row: any) => void;
}

const PageEvening: React.FC<PageEveningProops> = ({
  selectedIds,
  onToggleRow,
}) => {
  const { t } = useTranslate();
  const eveningColumns = getColumns(t);

  const topColumns: GridColDef[] = eveningColumns.map((col) =>
    col.field === "select"
      ? {
          ...col,
          renderCell: (params) => {
            const checked = selectedIds.includes(params.row.id);
            return (
              <ByzMuiCheckBox
                checked={checked}
                onChange={() => onToggleRow(params.row)}
              />
            );
          },
        }
      : col
  );
  return (
    <ByzMuiDataGrid
      sx={{ padding: "20px" }}
      customToolbar={ByzDataGridToolbar}
      rows={eveningRows}
      columns={topColumns}
      pageSize={5}
      disableProcessMenu
      autoHeight
    />
  );
};

export default PageEvening;
